export default __webpack_public_path__ + "static/media/product-details-5.1e25c0db.jpg";